import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  colors: {
    primary: '#287E3C', // Green - represents growth, prosperity, and hope
    secondary: '#00529C', // Blue - represents trust, stability, and reliability
    accent: '#F7941D', // Orange - represents warmth, energy, and enthusiasm
    background: '#F8F9FA', // Off-white - creates clean, professional look
    dark: '#333333', // Dark gray - for text and contrast elements
    light: '#FFFFFF', // White - for text on dark backgrounds
    darkBg: '#1A1A1A', // Darker background for contrast sections
    success: '#28a745',
    error: '#dc3545',
    lightGray: '#E9ECEF',
    mediumGray: '#6C757D',
  },

  fonts: {
    heading: '"Montserrat", sans-serif',
    body: '"Open Sans", sans-serif',
  },

  fontWeights: {
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },

  fontSizes: {
    xs: '0.75rem', // 12px
    sm: '0.875rem', // 14px
    md: '1rem',   // 16px
    lg: '1.25rem', // 20px
    xl: '1.5rem',  // 24px
    xxl: '2rem',   // 32px
    xxxl: '2.5rem', // 40px
    huge: '3rem',   // 48px
  },

  spacing: {
    xs: '0.25rem', // 4px
    sm: '0.5rem',  // 8px
    md: '1rem',    // 16px
    lg: '1.5rem',  // 24px
    xl: '2rem',    // 32px
    xxl: '3rem',   // 48px
    xxxl: '4rem',  // 64px
  },

  breakpoints: {
    xs: '320px',   // Mobile phones (small)
    sm: '576px',   // Mobile phones (large)
    md: '768px',   // Tablets
    lg: '992px',   // Desktops
    xl: '1200px',  // Large desktops
  },

  borderRadius: {
    sm: '0.25rem', // 4px
    md: '0.5rem',  // 8px
    lg: '1rem',    // 16px
    round: '50%',  // Circle
  },

  shadows: {
    sm: '0 2px 4px rgba(0, 0, 0, 0.1)',
    md: '0 4px 8px rgba(0, 0, 0, 0.12)',
    lg: '0 8px 16px rgba(0, 0, 0, 0.14)',
  },

  transitions: {
    fast: '0.2s ease',
    medium: '0.3s ease',
    slow: '0.5s ease',
  },
};

export default theme; 